import { useEffect, useState } from "react";
import { PageLoading } from "./components/Loading";
import ErrorMessage, { PageErrorContainer } from "./components/Error";
import { SecondaryButton } from "./components/buttons/SecondaryButton";
import { useClerk } from "@clerk/clerk-react";
import { useDispatch } from "react-redux";

const LoadToError = ({ isFetching = false }: { isFetching?: boolean }) => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const { signOut } = useClerk();

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 5000);
  }, [isFetching]);

  if (isLoading || isFetching) {
    return <PageLoading />;
  }

  return (
    <PageErrorContainer>
      <ErrorMessage>
        It looks like there was an error loading the page. Please sign out and
        try again or contact support.
      </ErrorMessage>
      <div style={{ display: "flex", gap: "12px", marginTop: "16px" }}>
        <SecondaryButton
          css={{ width: "fit-content" }}
          onClick={async () => {
            dispatch({ type: "USER_LOGOUT" });
            await signOut({ redirectUrl: "/login" });
          }}
        >
          Log out
        </SecondaryButton>
      </div>
    </PageErrorContainer>
  );
};

export default LoadToError;
